import React from "react";
import { getStudents } from "../../queries/students";
import { TextFilter } from "../../components/Overview/Filters/TextFilter";
import { getUsers } from "../../queries/users";
import moment from "moment";
import { DateFilter } from "../../components/Overview/Filters/DateFilter";

export const RowStructure = (props) => {
    return (
        <tr
            onClick={() => {
                props.onClick(props);
            }}
            key={props.id}
        >
            <td>{props.nibhv_number}</td>
            <td>
                <div className="overview-redux__truncated-text" title={props.first_name}>
                    {props.first_name}
                </div>
            </td>
            <td>
                <div className="overview-redux__truncated-text" title={props.last_name_starts}>
                    <b>{props.last_name_starts}</b>
                </div>
            </td>
            <td>
                <div className="overview-redux__truncated-text" title={props.date_of_birth}>
                    {props?.date_of_birth ? moment(props.date_of_birth).format("DD-MM-YYYY") : "Nog niet ingevuld"}
                </div>
            </td>
            <td>
                <div className="overview-redux__truncated-text" title={props.email}>
                    {props.email}
                </div>
            </td>
        </tr>
    );
};

export const UserOverviewBase = {
    queryFn: getUsers,
    RowStructure,
    search: {},
    columns: [
        {
            title: "NIBHV#",
            columnIdentifier: "nibhv_number",
            placeholder: "",
            orderable: true,
            Filter: TextFilter,
            className: "overview-redux__head--width-nibhv-number"
        },
        {
            title: "Voornaam",
            columnIdentifier: "first_name",
            placeholder: "",
            orderable: true,
            Filter: TextFilter,
            className: "overview-redux__head--width-first-name"
        },
        {
            title: "Achternaam",
            columnIdentifier: "last_name_starts",
            placeholder: "",
            orderable: true,
            Filter: TextFilter,
            className: "overview-redux__head--width-last-name"
        },
        {
            title: "Geb. datum",
            columnIdentifier: "date_of_birth",
            placeholder: "DD-MM-JJJJ",
            orderable: true,
            Filter: DateFilter,
            className: "overview-redux__head--width-date-of-birth"
        },
        {
            title: "Email",
            columnIdentifier: "email",
            placeholder: "",
            orderable: true,
            Filter: TextFilter,
            className: "overview-redux__head--width-email"
        },
        {
            columnIdentifier: "uuid",
            noDisplay: true
        },
        {
            columnIdentifier: "full_name",
            noDisplay: true
        }
    ],
    defaults: {
        ordering: {
            columnIdentifier: "last_name_starts",
            direction: ""
        },

        filter: {
            // state: ["open"],
        }
    }
};

export const StudentOverviewBase = {
    ...UserOverviewBase,
    queryFn: getStudents
};
